import styled from 'styled-components'

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`

CheckboxWrapper.displayName = 'CheckboxWrapper'
export default CheckboxWrapper
